import Price from '../../../../../appData/price'
import { useBlackFriday } from '../../../../../context/blackFridayContext'
import useStrings from '../../../../../localization/useStrings'
import styles from './Payment.module.scss'

const Payment = () => {
  const strings = useStrings().premiumToUltimateBlackFriday

  const { state, actions } = useBlackFriday()

  const pricing = state.ultimatePricing

  const totalPrice = pricing.yearlyPriceFull.formatted
  const discountedPrice = pricing.yearlyPriceDiscounted.formatted

  const yearlyPerMonthPrice = pricing.discountedMonthlyPrice.formatted

  const monthlyPrice = new Price(pricing.baseProduct.price, pricing.baseProduct.priceLocale)
    .formatted

  const title = state.isUltimateLaunch ? strings.ultimateLaunch.saleTitle : strings.saleTitle

  return (
    <div className={styles.container}>
      <button
        className={styles.yearlyContainer}
        onClick={() => {
          actions.purchaseYearly()
        }}
      >
        <div className={styles.bannerContainer}>
          <label className={styles.yearlyBannerTitle}>{strings.saleBanner}</label>
        </div>
        <div className={styles.yearlyInfo}>
          <label className={styles.yearlyTitle}>{title}</label>
          <div className={styles.subtitle}>
            <label>
              {strings.monthPrefix}
              <label style={{ textDecoration: "line-through", textDecorationThickness: 2 }}>
                {totalPrice}
              </label>
              {" " + discountedPrice}
            </label>
            <label>{strings.perMonthPrice(yearlyPerMonthPrice)}</label>
          </div>
        </div>
      </button>
      <button
        className={styles.monthlyContainer}
        onClick={() => {
          actions.purchaseMonthly()
        }}
      >
        <div className={`${styles.subtitle} ${styles.subtitleMonthly}`}>
          <label>{strings.monthly}</label>
          <label>{strings.perMonthPrice(monthlyPrice)}</label>
        </div>
      </button>
    </div>
  )
}

export default Payment
